export default defineNuxtPlugin((nuxtApp) => {
  const toast = useToast()
  let notified = false

  // Fires for failed route chunks (app:chunkError) and failed dynamic imports like
  // lazy components (vite:preloadError), typically after a deploy replaced hashed chunks.
  function notifyStaleApp(error: unknown) {
    console.error('caught chunk load error', error)
    if (notified) return
    notified = true
    toast.add({
      title: 'App update required',
      description: 'Part of the app failed to load, probably because a new version was deployed.',
      color: 'red',
      timeout: 0,
      actions: [
        {
          label: 'Reload',
          click: () => reloadNuxtApp({ persistState: true }),
        },
      ],
    })
  }

  nuxtApp.hook('app:chunkError', ({ error }) => notifyStaleApp(error))
  window.addEventListener('vite:preloadError', (event) => notifyStaleApp(event.payload))
})
